<template>
  <div class="userManage contentBack">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>系统设置 </el-breadcrumb-item>
      <el-breadcrumb-item class="breadSelected">用户管理 </el-breadcrumb-item>
    </el-breadcrumb>
    <div class="titleH2">
      
       用户管理
    </div>
    <!-- 搜索用户 -->
    <div style="display: flex; margin-left: 20px; margin-top: 17px">
      <el-input
        id="input1"
        v-model="unameInput"
        placeholder="请输入联系电话/账号/姓名"
      ></el-input
      ><el-button id="btn1" type="primary" @click="searchByName"
        >搜 索</el-button
      >
    </div>
    <!-- 用户列表 -->
    <div id="userLIst">
      <div class="listTitle">用户列表</div>
      <div id="addOrdeleteUser">
        <el-button size="small" @click="addUser"
          ><i
            class="el-icon-circle-plus-outline"
            style="color: #47a909; font-size: 14px; margin-right: 5px"
          ></i
          >添加用户</el-button
        >
        <el-button size="small" @click="deleteUsers"
          ><i
            class="el-icon-remove-outline"
            style="color: #d5146d; font-size: 14px; margin-right: 5px"
          ></i
          >删除用户</el-button
        >
      </div>
      <el-table
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
        @selection-change="handleSelectionChange"
        border
        max-height="60vh"
        @sort-change="sortbysex"
      >
        <!-- 选择框 -->
        <el-table-column :resizable="false" type="selection" width="40">
        </el-table-column>
        <!-- 序号 -->
        <el-table-column
          :resizable="false"
          label="序号"
          width="50"
          type="index"
        >
          <!-- <template slot-scope="scope">{{ scope.row.id }}</template> -->
        </el-table-column>
        <!-- 账号 -->
        <el-table-column
          :resizable="false"
          prop="account"
          label="账号"
        ></el-table-column>
        <!-- 姓名 -->
        <el-table-column
          :resizable="false"
          prop="name"
          label="姓名"
          width="80"
        ></el-table-column>
        <!-- 性别 -->
        <el-table-column
          :resizable="false"
          prop="sex"
          label="性别"
          sortable="custom"
          min-width="80"
        >
        </el-table-column>
        <!-- 联系电话 -->
        <el-table-column
          :resizable="false"
          prop="phone"
          label="联系电话"
          width="115"
        >
        </el-table-column>
        <!-- 数据权限 -->
        <el-table-column :resizable="false" prop="dataPrmName" label="数据权限">
        </el-table-column>
        <!-- 功能权限 -->
        <el-table-column
          :resizable="false"
          prop="functionPrmName"
          label="功能权限"
        >
        </el-table-column>
        <!-- 创建日期 -->

        <el-table-column
          :resizable="false"
          prop="createTime"
          label="创建日期"
          width="110"
          sortable="custom"
        >
        </el-table-column>
        <!-- 操作  -->
        <el-table-column :resizable="false" label="操作" width="300">
          <template slot-scope="scope">
            <div id="userHandle">
              <a @click="openModify(scope.$index, tableData)">修改信息</a>
              <span>|</span>
              <el-popconfirm
                class="userPop"
                width="176"
                icon="el-icon-warning"
                icon-color="#FAAD14"
                v-model="resetBox"
                title="点击确定可重置该密码"
                placement="top"
                @confirm="resetConfirm"
                style="display: block; min-width: 77px"
              >
                <a slot="reference" @click="resetPwd(scope.$index, tableData)"
                  >重置密码</a
                >
              </el-popconfirm>
              <span>|</span>
              <a @click="deleteUser(scope.$index, tableData)">删 除</a>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div class="page-pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 15, 20]"
        :page-size="10"
        layout="total, sizes, prev, pager, next, jumper"
        :total="userNums"
      >
      </el-pagination>
        <el-button size="mini" type="primary" style="margin-left: 5px"
          >确定</el-button
        >
      
    </div>
    <!-- 弹框 -->
    <!-- 添加用户 -->
    <div v-if="updataBox" class="popBoxMask"></div>
    <div v-if="updataBox" class="popBox">
      <div class="boxHeader">
        添加用户
        <i class="el-icon-close" @click="closeTkAdduser"> </i>
      </div>
      <div class="boxContent">
        <div class="listTitle titleBold">设置账号信息</div>
        <div class="boxForm">
          <div
            style="display: flex; width: 100%; justify-content: space-between"
          >
            <div class="accountMsg">
              <div><span>*</span>登录账号：</div>
              <input
                type="text"
                v-model="adduserMsg.uid"
                placeholder="请输入"
              />
            </div>
            <div class="accountMsg">
              <div><span>*</span>登录权限：</div>
              <select name="登录权限" v-model="adduserMsg.islogin">
                <option value="1">开</option>
                <option value="0">关</option>
              </select>
            </div>
            <div class="accountMsg">
              <div>性别：</div>
              <select name="性别" v-model="adduserMsg.sex">
                <option value="1">男</option>
                <option value="0">女</option>
              </select>
            </div>
          </div>
          <div
            style="
              display: flex;
              width: 100%;
              justify-content: space-between;
              margin-top: 2.5%;
            "
          >
            <div class="accountMsg">
              <div><span>*</span>登录密码：</div>
              <input
                type="text"
                v-model="adduserMsg.pwd"
                placeholder="请输入"
              />
            </div>
            <div class="accountMsg">
              <div><span>*</span>姓名：</div>
              <input
                type="text"
                v-model="adduserMsg.uname"
                placeholder="请输入"
              />
            </div>
            <div class="accountMsg">
              <div>联系电话：</div>
              <input
                type="text"
                v-model="adduserMsg.phone"
                placeholder="请输入"
              />
            </div>
          </div>
        </div>
        <div class="listTitle titleBold" style="margin-top: 10px">
          设置数据权限
        </div>
        <div class="boxForm dataForm" style="display: flex">
          <div class="formTitletext"><span>*</span>数据范围权限：</div>

          <el-checkbox
            class="checkall1"
            v-model="checkAlldata"
            @change="handleCheckAllChangeData"
            >全选</el-checkbox
          >
          <el-checkbox-group
            v-model="adduserMsg.data"
            @change="handleCheckedCompanyChangeData"
          >
            <el-checkbox
              v-for="(region, index) of dataRegions"
              :key="index"
              :label="region"
              name="data"
              >{{ region | permissionFilter }}</el-checkbox
            >
          </el-checkbox-group>
        </div>

        <div class="listTitle titleBold" style="margin-top: 10px">
          设置功能权限
        </div>
       
        <div class="boxForm dataForm" style="display: flex;flex-wrap: wrap;">
           <div style="width: 14%" class="formTitletext">
            <span>*</span>功能权限：
          </div>
          
              <el-checkbox
            class="checkall1"
            v-model="checkAllfunc"
            @change="handleCheckAllChangeFunc"
            >全选</el-checkbox
          >
         
  
          <el-checkbox-group
            v-model="adduserMsg.func"
            @change="handleCheckedCompanyChangeFunc"
          >
            <el-checkbox
              v-for="(func, index) of funcNames"
              :key="index"
              :label="func"
              name="func"
              >{{ func | permissionFilter }}</el-checkbox
            >
          </el-checkbox-group>
        </div>
        <div style="display: flex; margin-top: 4%; justify-content: center">
          <el-button class="btn2" @click="cancelAdd">取消</el-button>
          <el-button class="btn2" type="primary" @click="confirmAdd"
            >确认添加</el-button
          >
        </div>
      </div>
    </div>
    <!-- 修改信息 -->
    <div v-if="ModifyBox" class="popBoxMask"></div>
    <div v-if="ModifyBox" class="popBox">
      <div class="boxHeader">
        修改用户信息
        <i class="el-icon-close" @click="closeTkModify"> </i>
      </div>
      <div class="boxContent">
        <div class="listTitle titleBold">修改账号信息</div>
        <div class="boxForm">
          <div
            style="display: flex; width: 100%; justify-content: space-between"
          >
            <div class="accountMsg">
              <div>登录账号：</div>
              <input type="text" :value="updateMsg.account" disabled />
            </div>
            <div class="accountMsg">
              <div><span>*</span>登录权限：</div>
              <select name="登录权限" v-model="updateMsg.isAccess">
                <option value="1">开</option>
                <option value="0">关</option>
              </select>
            </div>
            <div class="accountMsg">
              <div>性别：</div>
              <select name="性别" v-model="updateMsg.sex">
                <option value="1">男</option>
                <option value="0">女</option>
              </select>
            </div>
          </div>
          <div
            style="
              display: flex;
              width: 100%;
              justify-content: space-between;
              margin-top: 2.5%;
            "
          >
            <div class="accountMsg">
              <div><span>*</span>登录密码：</div>
              <input type="text" v-model="updateMsg.password" />
            </div>
            <div class="accountMsg">
              <div><span>*</span>姓名：</div>
              <input type="text" v-model="updateMsg.name" />
            </div>
            <div class="accountMsg">
              <div>联系电话：</div>
              <input
                type="text"
                v-model="updateMsg.phone"
                placeholder="请输入电话号码"
              />
            </div>
          </div>
        </div>
        <div class="listTitle titleBold" style="margin-top: 10px">
          修改数据权限
        </div>
        <div class="boxForm dataForm" style="display: flex">
          <div class="formTitletext"><span>*</span>数据范围权限：</div>

          <el-checkbox
            class="checkall1"
            v-model="checkAlldata1"
            @change="handleCheckAllChangeData1"
            >全选</el-checkbox
          >
          <el-checkbox-group
            v-model="updateMsg.dataPrmId"
            @change="handleCheckedCompanyChangeData1"
          >
            <el-checkbox
              v-for="(region, index) of dataRegions"
              :key="index"
              :label="region"
              name="data"
              >{{ region | permissionFilter }}</el-checkbox
            >
          </el-checkbox-group>
        </div>

        <div class="listTitle titleBold" style="margin-top: 10px">
          修改功能权限
        </div>
        <div class="boxForm dataForm" style="display: flex; flex-wrap: wrap;">
          <div style="width: 34%" class="formTitletext">
            <span>*</span>功能权限：
          </div>

          <el-checkbox
            class="checkall1"
            v-model="checkAllfunc1"
            @change="handleCheckAllChangeFunc1"
            >全选</el-checkbox
          >
          <el-checkbox-group
            v-model="updateMsg.functionPrmId"
            @change="handleCheckedCompanyChangeFunc1"
          >
            <el-checkbox
              v-for="(func, index) of funcNames"
              :key="index"
              :label="func"
              name="func"
              >{{ func | permissionFilter }}</el-checkbox
            >
          </el-checkbox-group>
        </div>
        <div style="display: flex; margin-top: 4%; justify-content: center">
          <el-button class="btn2" @click="cancelUpdate">取消</el-button>
          <el-button class="btn2" type="primary" @click="confirmUpdate"
            >确认修改</el-button
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Message } from "element-ui";
import { Encrypt } from "@/plugins/crypto.js";
export default {
  data() {
    return {
      unameInput: "",
      tableData: [],
      multipleSelection: [], // 多选项
      currentPage: 1,
      userNums: 0,
      updataBox: false,
      ModifyBox: false,
      adduserMsg: {
        uid: "",
        islogin: "1",
        sex: 1,
        pwd: "",
        uname: "",
        phone: "",

        data: [],
        func: [],
      },

      updateMsg: {},
      dataRegions: ["03", "05", "04", "06", "13", "07", "08", "09", "10", "11","12"],
      funcNames: [
        "16",
        "18",
        "19",
        "20",
        "21",
        "25",
        "26",
        "27",
        "30",
        "31"
      ],
      checkAlldata: false,
      checkAllfunc: false,
      checkAlldata1: false,
      checkAllfunc1: false,
      issplit: true,
      resetBox: false,
      resetUser: {},
      keyword: "",
      pageNum: 1,
      pageSize: 10,
      order: "",
      orderType: "",
    };
  },
  methods: {
    //   封装获取用户信息的方法
    getUsersList(keyword, pageNum = 1, pageSize = 10, order, orderType) {
      this.$GET("/user/search", {
        keyword: keyword,
        pageNum: pageNum,
        pageSize: pageSize,
        order: order,
        orderType: orderType,
      }).then((res) => {
        let aa = [];
        let usersData = res.data.list;
        // console.log('-----',usersData)
        
        this.userNums = res.data.total;
        for (let i = 0; i < usersData.length; i++) {
          const {
            name,
            sex,
            phone,
            dataPrmName,
            functionPrmName,
            createTime,
            id,
            account,
            isAccess,
            password,
            dataPrmId,
            functionPrmId,
          } = usersData[i];
          aa.push({
            name,
            sex,
            phone,
            dataPrmName,
            functionPrmName,
            createTime,
            id,
            account,
            isAccess,
            password,
            dataPrmId,
            functionPrmId,
          });
        }
        // for (let j = 0; j < aa.length; j++) {
        //   aa[j].createTime = aa[j].createTime.split(" ")[0];
        // }
        this.tableData = aa;
        // console.log(aa)
        // if(aa.dataPrmId.length==9){
        //   this.checkAlldata1=true
        // }
      });
    },
    
    // 查询用户
    searchByName() {
      this.getUsersList(this.unameInput);
      this.keyword = this.unameInput;
    },
    // 排序
    sortbysex(column, prop, order) {
      // console.log(column.prop)
      // console.log(prop)
      // console.log(column.order)
      if (column.prop == "sex") {
        this.order = "sex";
        if (column.order == "descending") {
          this.getUsersList(
            this.keyword,
            this.pageNum,
            this.pageSize,
            "sex",
            "desc"
          );
          this.orderType = "desc";
        } else if (column.order == "ascending") {
          this.getUsersList(
            this.keyword,
            this.pageNum,
            this.pageSize,
            "sex",
            "asc"
          );
          this.orderType = "asc";
        }
      } else if (column.prop == "createTime") {
        this.order = "create_time";

        if (column.order == "descending") {
          this.orderType = "desc";

          this.getUsersList(
            this.keyword,
            this.pageNum,
            this.pageSize,
            "create_time",
            "desc"
          );
        } else {
          this.getUsersList(
            this.keyword,
            this.pageNum,
            this.pageSize,
            "create_time",
            "asc"
          );
          this.orderType = "asc";
        }
      }
    },
    // 添加用户
    addUser() {
      //   this.adduserMsg=this.adduserMsg2
      this.updataBox = true;
    },
    closeTkAdduser() {
      //关闭弹框
      this.updataBox = false;
      //   this.adduserMsg=this.adduserMsg2
      this.adduserMsg.uid = "";
      this.adduserMsg.islogin = "1";
      this.adduserMsg.sex = 1;
      this.adduserMsg.pwd = "";
      this.adduserMsg.uname = "";
      this.adduserMsg.phone = "";
      this.adduserMsg.data = [];
      this.adduserMsg.func = [];
      //   Object.keys(this.adduserMsg).forEach(
      //     (key) => (this.adduserMsg[key] = "")
      //   );
    },
    closeTkModify() {
      this.ModifyBox = false;
      // for(let key in this.updateMsg){
      //   this.updateMsg[key]=""
      // }
      this.updateMsg={}
    },
    cancelAdd() {
      //取消添加
      this.updataBox = false;
      this.adduserMsg.uid = "";
      this.adduserMsg.islogin = "1";
      this.adduserMsg.sex = 1;
      this.adduserMsg.pwd = "";
      this.adduserMsg.uname = "";
      this.adduserMsg.phone = "";
      this.adduserMsg.data = [];
      this.adduserMsg.func = [];

      //   Object.keys(this.adduserMsg).forEach(
      //     (key) => (this.adduserMsg[key] = "")
      //   );
    },
    cancelUpdate() {
      this.ModifyBox = false;
      // for(let key in this.updateMsg){
      //   this.updateMsg[key]=""
      // }
      this.updateMsg={}
    },
    confirmAdd() {
      // debugger;
      // this.updataBox = false;

      //确认添加
      // let Form=JSON.stringify(this.adduserMsg)
      let prmId = JSON.stringify(
        this.adduserMsg.data.concat(this.adduserMsg.func)
      );
      let sex = this.adduserMsg.sex == 1 ? "男" : "女";
      // console.log(sex);
      let Form = {
        account: this.adduserMsg.uid,
        name: this.adduserMsg.uname,
        sex: sex,
        password: Encrypt(this.adduserMsg.pwd),
        isAccess: this.adduserMsg.islogin,
        phone: this.adduserMsg.phone,
        prmId: prmId,
      };
      var that = this;
      this.$post("/user/add", Form).then((res) => {
        // console.log(res);
        that.adduserMsg.uid = "";
        that.adduserMsg.islogin = "1";
        that.adduserMsg.sex = 1;
        that.adduserMsg.pwd = "";
        that.adduserMsg.uname = "";
        that.adduserMsg.phone = "";
        that.adduserMsg.data = [];
        that.adduserMsg.func = [];

        if (res.status == 200) {
          that.getUsersList();

           this.updataBox = false;
          Message({ message: "添加成功", type: "success", duration: 5000 });
        } else {
          this.updataBox = true;
          Message({ message: res.msg });
          // console.log(res.msg)
        }
      });
    },
    handleCheckAllChangeData(val) {
      val
        ? (this.adduserMsg.data = this.dataRegions)
        : (this.adduserMsg.data = []);
    },
    handleCheckedCompanyChangeData(value) {
      let checkedCount = value.length;
      this.checkAlldata = checkedCount === this.dataRegions.length;
      this.adduserMsg.data = value;
    },
    handleCheckAllChangeFunc(val) {
      val
        ? (this.adduserMsg.func = this.funcNames)
        : (this.adduserMsg.func = []);
    },
    handleCheckedCompanyChangeFunc(value) {
      let checkedCount = value.length;
      this.checkAllfunc = checkedCount === this.funcNames.length;
      this.adduserMsg.func = value;
    },
    // 批量删除用户
    deleteUsers() {
      if (this.multipleSelection.length > 0) {
        this.$confirm("是否确定删除选中用户信息操作？", "温馨提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            let uid = [];
            this.multipleSelection.forEach((ele) => {
              uid.push(ele.id);
            });
            let uids = uid.join(";");

            let data = {
              token: localStorage.getItem("token"),
              uid: uids,
            };
            this.$post("/user/delete", data).then((res) => {
              if (res.status == 200) {
                this.multipleSelection = [];
                this.getUsersList(
                  this.keyword,
                  this.pageNum,
                  this.pageSize,
                  this.order,
                  this.orderType
                );
                Message({
                  message: "删除成功",
                  type: "success",
                  duration: 5000,
                });
              } else {
                Message({ message: res.msg });
              }
            });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除",
            });
          });
      } else {
        Message({ message: "请勾选用户" });
      }
    },
    // 删除单个用户
    deleteUser(index, tableData) {
      //   console.log(index);
      //   console.log(tableData);

      this.$confirm("是否确定删除该用户信息操作？", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let data = {
            token: localStorage.getItem("token"),
            uid: this.tableData[index].id,
          };
          this.$post("/user/delete", data).then((res) => {
            // console.log(res);
            if (res.status == 200) {
              this.getUsersList(
                this.keyword,
                this.pageNum,
                this.pageSize,
                this.order,
                this.orderType
              );
              Message({ message: "删除成功", type: "success", duration: 5000 });
            } else {
              Message({ message: res.msg });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 修改用户信息
    openModify(index, tableData) {
      // this.updateMsg = JSON.parse('{}');
      // for(let key in this.updateMsg){
      //   this.updateMsg[key]=''
      // }
      this.issplit=true
      this.ModifyBox = true;
      // debugger;
      this.updateMsg = JSON.parse(JSON.stringify(tableData[index]));
      // console.log(this.updateMsg)
      this.updateMsg.sex = this.updateMsg.sex == "男" ? "1" : "0";
      if (this.issplit) {
        this.updateMsg.dataPrmId = this.updateMsg.dataPrmId.split(";");
        this.updateMsg.functionPrmId = this.updateMsg.functionPrmId.split(";");
        if (this.updateMsg.dataPrmId.length == 11) {
          this.checkAlldata1 = true;
        }
        if (this.updateMsg.functionPrmId.length == 16) {
          this.checkAllfunc1 = true;
        }
        // console.log(this.updateMsg.dataPrmId)
        this.issplit = false;
      } else {
        this.issplit = true;
      }
    },
    // 重置密码
    resetPwd(index, tableData) {
      this.resetBox = true;
      let resetUser = {};
      resetUser.uid = tableData[index].id;
      resetUser.token = localStorage.getItem("token");
      this.resetUser = resetUser;
    },
    resetConfirm() {
      this.$post("/user/rest", this.resetUser).then((res) => {
        if (res.status == 200) {
          Message({ message: "重置密码成功" });
        } else {
          Message({ message: res.msg });
        }
      });
    },
    handleCheckAllChangeData1(val) {
      val
        ? (this.updateMsg.dataPrmId = this.dataRegions)
        : (this.updateMsg.dataPrmId = []);
    },
    handleCheckedCompanyChangeData1(value) {
      let checkedCount = value.length;
      this.checkAlldata1 = checkedCount === this.dataRegions.length;
      this.updateMsg.dataPrmId = value;
    },
    handleCheckAllChangeFunc1(val) {
      val
        ? (this.updateMsg.functionPrmId = this.funcNames)
        : (this.updateMsg.functionPrmId = []);
    },
    handleCheckedCompanyChangeFunc1(value) {
      let checkedCount = value.length;
      this.checkAllfunc1 = checkedCount === this.funcNames.length;
      this.updateMsg.functionPrmId = value;
    },
    // 确认修改
    confirmUpdate() {
      let prmId = this.updateMsg.dataPrmId.concat(this.updateMsg.functionPrmId);
      prmId = prmId.join(";");
      let sex = this.updateMsg.sex == "1" ? "男" : "女";
      let Form = {
        id: this.updateMsg.id,
        prmId: prmId,
        isAccess: this.updateMsg.isAccess,
        sex: sex,
        name: this.updateMsg.name,
        phone: this.updateMsg.phone,
        password: Encrypt(this.updateMsg.password),
      };
      var that = this;
      this.$post("/user/update", Form).then((res) => {
        // console.log(res);
        that.ModifyBox = false;

        if (res.status == 200) {
          that.getUsersList(
            this.keyword,
            this.pageNum,
            this.pageSize,
            this.order,
            this.orderType
          );
          Message({ message: "修改成功", type: "success", duration: 5000 });
        } else {
          Message({ message: res.msg });
        }
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleSizeChange(val) {
      this.pageSize = val;
      if (val == 15) {
        this.getUsersList(
          this.keyword,
          this.pageNum,
          15,
          this.order,
          this.orderType
        );
      } else if (val == 20) {
        this.getUsersList(
          this.keyword,
          this.pageNum,
          20,
          this.order,
          this.orderType
        );
      } else
        this.getUsersList(
          this.keyword,
          this.pageNum,
          10,
          this.order,
          this.orderType
        );
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      this.getUsersList(
        this.keyword,
        val,
        this.pageSize,
        this.order,
        this.orderType
      );
    },
  },
  mounted() {
    this.getUsersList();
  },
  watch: {
    currentPage(val) {
      this.getUsersList(
        this.keyword,
        val,
        this.pageSize,
        this.order,
        this.orderType
      );
    },
  },
  //   updated(){
  //       console.log(this.adduserMsg.sex)
  //   }
};
</script>
<style>
@media (max-width: 1600px) {
  /* .popBox {
    margin-top: -39vh !important;
  } */
  .dataForm .el-checkbox {
    margin-bottom: 10px !important;
  }
}
.titleH2 {
  color: #1471d5;
  font-weight: 700;
  font-size: 16px;
  margin-left: 24px;
  margin-top: 22px;
  display: flex;
  align-items: center;
}

.titleH2::before {
	  content: '';
		width: 4px;
		height: 16px;
		background: #2b7bfd;
		border-radius: 2px;
		display: inline-block;
		margin-right: 10px;
}


.breadSelected span {
  color: #0064d0 !important;
  /* font-weight: bold !important; */
}
.userManage #input1.el-input__inner {
  width: 100%;
  border-top-left-radius: 3px;
  border-bottom-left-radius: 3px;
  font-size: 14px;
}
#btn1.el-button {
  border-radius: 0px;
}
.userManage .el-input {
  width: 26%;
}
#userLIst {
  margin-left: 20px;
  position: relative;
  margin-top: 23px;
  width: 98%;
}
.el-table {
  font-size: 13px;
  color: #474747;
  overflow: auto !important;
}
.el-table th {
  background: #e7f3ff !important;
  padding: 2px 0 !important;
}
.el-table td {
  padding: 8px 0 !important;
}
.el-table th > .cell {
  text-align: center;
  font-size: 14px;
  color: #000;
  font-weight: bold;
}
.el-table .cell {
  text-align: center;
}

#addOrdeleteUser {
  position: absolute;
  right: 10px;
  top: 4px;
  z-index: 9;
}
#addOrdeleteUser .el-button--small,
.el-button--small.is-round {
  padding: 5px 4px;
}
.el-table--border,
.el-table--group {
  border: 1px solid #ddd;
}
.el-table__header-wrapper {
  height: 40px !important;
}
#userHandle {
  display: flex;
  color: #055fe6;
  position: relative;
}
#userHandle .resetPwdbox {
  position: absolute;
  width: 176px;
  height: 82px;
  background: #fff;
  box-shadow: 0, 0, 20px, gray;
}
#userHandle a {
  display: block;
  cursor: pointer;
  color: #055fe6;
  font-size: 12px;
}
#userHandle > a:last-child {
  color: #ff7119;
}
.popBoxMask {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
}
.popBox {
  width: 45vw;
  min-width: 615px;
  background: white;
  position: fixed;
  left: 50%;
  top: 50%;
  margin-left: -22vw;
  margin-top: -30vh;
  z-index: 999;
}
.popBox .boxHeader {
  height: 50px;
  width: 100%;
  text-align: center;
  line-height: 50px;
  font-size: 20px;
  color: #fff;
  letter-spacing: 1px;
  background: #1471d5;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  margin-top: -50px;
}
.popBox .boxContent {
  /* width: 95%; */
  padding: 15px 20px;
  max-height: 64vh;
  overflow-y: auto;
}
.titleBold {
  font-weight: bold;
}
.boxForm {
  border: 1px solid #dddddd;
  /* width: 95%; */
  padding: 15px 20px;
}
.boxForm .accountMsg {
  display: flex;
  width: 30%;
}
.boxForm .accountMsg span {
  font-size: 14px;
  color: #d5146d;
  margin-top: 5px;
  margin-right: 2px;
  text-align: right;
}
.formTitletext span {
  font-size: 14px;
  color: #d5146d;
  margin-right: 2px;
}
.formTitletext {
  font-size: 14px;
  color: #333;
  width: 52%;
  margin-right: 10px;
}
.boxForm .accountMsg > div {
  font-size: 14px;
  color: #333;
  width: 157px;
  margin-top: 5px;
  text-align: right;
}
.boxForm .accountMsg input {
  width: 59%;
  padding: 6px 17px;
  border: 1px solid #dbdbdb;
  height: 18px;
  outline: 0;
}
.boxForm .accountMsg select {
  width: 59%;
  padding: 6px 17px;
  border: 1px solid #dbdbdb;
  height: 32px;
}
.dataForm .el-checkbox {
  margin-bottom: 19px;
}
.dataForm {
  padding: 15px 20px 0;
}
.checkall1.el-checkbox {
  margin-right: 26px !important;
}
.btn2.el-button {
  width: 136px;
}
.btn2.el-button:last-child {
  background: #1471d5;
}
.btn2.el-button:last-child:hover {
  background: #0f549e;
}
.el-icon-close {
  color: #fff;
  font-weight: bold !important;
  float: right;
  font-size: 24px;
  margin-top: 10px;
  margin-right: 10px;
  cursor: pointer;
}
/* .userPop.el-popconfirm__main {
    
    margin-bottom: 11px !important;
    font-size: 12px  !important;
}
.userPop.el-popconfirm__main i{
    font-size: 16px !important;
} */
</style>